import { globals } from '../utils/globals';

export class DwChat {
  open(): void {
    // Contentful feature flag controls the migration to the new Five9 (F9) chat.
    if (globals.releaseFlags?.ENABLE_F9_CHAT) {
      this.openF9();
      return;
    }

    this.openLegacy();
  }

  private openF9(): void {
    // FIVN is the global Five9 chat widget, loaded via GTM.
    if (window.FIVN?.isOpened && !window.FIVN.isOpened()) {
      window.FIVN.open();
    }
  }

  private openLegacy(): void {
    // This id (element) and the chat widget is setup via GTM. Element id: hackathon-widget-button
    const chatWidgetElement = document.getElementById('hackathon-widget-button');

    // Trigger a click on the chat widget element, when the footer Link is clicked.
    if (chatWidgetElement) {
      chatWidgetElement.click();
    }
  }
}

export const dwChat = new DwChat();
